var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"font-bold lg:text-3xl text-EXPONDO-black",class:[_vm.headerClass, _vm.isSmall ? 'text-xs' : 'text-xl']},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }